.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  color: var(--color-accent-fg);
  font-weight: var(--weight-semibold);
  line-height: 1;
  user-select: none;
}

.sm {
  width: var(--size-avatar-sm);
  height: var(--size-avatar-sm);
  font-size: var(--text-2xs);
}

.md {
  width: var(--size-avatar);
  height: var(--size-avatar);
  font-size: var(--text-xs);
}

.person1 {
  background: var(--color-person-1);
}
.person2 {
  background: var(--color-person-2);
}
.person3 {
  background: var(--color-person-3);
}
.person4 {
  background: var(--color-person-4);
}
.person5 {
  background: var(--color-person-5);
}
.person6 {
  background: var(--color-person-6);
}

.more {
  background: var(--color-surface-sunken);
  color: var(--color-fg-muted);
}

.stack {
  display: inline-flex;
  align-items: center;
}

/* A thin ring in the card colour the stack sits on (a card sets --avatar-ring), so avatars never run together. */
.stacked {
  box-shadow: 0 0 0 var(--avatar-ring-width, 1.5px) var(--avatar-ring, var(--color-surface));
}

.stacked + .stacked {
  margin-left: calc(var(--space-1-5) * -1);
}
